import { render, staticRenderFns } from "./Venues.vue?vue&type=template&id=fcaa0c84&scoped=true"
import script from "./Venues.vue?vue&type=script&lang=js"
export * from "./Venues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaa0c84",
  null
  
)

export default component.exports